import { Box, Container, Typography, Grid } from '@material-ui/core'
import React, { useEffect } from 'react'
import ReactPlayer from 'react-player'
import VideoPulseButton from '../Video/VideoPulseButton'
import VideoButton from '../Video/VideoButton'
import CustomButton from '../Button/CustomButton'
// import HeroAnimation from '../Animations/HeroAnimation'
// import Hero2Animation from '../Animations/Hero2Animation'
// import Hero3Animation from '../Animations/Hero3Animation'
import ImgSet from '../Other/ImgSet'
import {
  SectionHeaderSmall,
  TitleH2Bold,
  TitleH2BoldLarge,
  TitleH3Bold
} from '../../theme/typography'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'proptypes'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { uppercaseString } from '../../utils'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: (props) => (props.banner ? 2 : 0),
    maxWidth: (props) => (props.maxwitdth ? props.maxwitdth : '100%'),
    margin: (props) => (props.maxwitdth ? 'auto' : 0),
    overflow: (props) => (props.bgVideoUrl ? 'hidden' : 'visible'),
    padding: theme.spacing(10, 0),
    paddingBottom: (props) =>
      props.pb
        ? props.pb
        : props.banner || props.whiteStripe
        ? theme.spacing(2)
        : props.pbsmall
        ? theme.spacing(5)
        : theme.spacing(10),
    paddingTop: (props) =>
      props.secondaryMenu
        ? theme.spacing(15)
        : props.ptsmall
        ? theme.spacing(7)
        : theme.spacing(10),
    backgroundColor: (props) => (props.bgColor ? props.bgColor : theme.colors.white),
    color: (props) => (props.color === '#ffffff' ? theme.colors.white : theme.colors.blue5),
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundImage: (props) => (props.imgUrl ? `url(${props.imgUrl})` : ''),
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: (props) => (props.transparency ? 0.1 : 1),
      filter: (props) => (props.transparency ? 'grayscale(1)' : '')
    },
    '&::after': {
      content: (props) => (props.transparency || props.whiteStripe ? '""' : ''),
      position: 'absolute',
      width: '100%',
      height: (props) => (props.whiteStripe ? 100 : '70%'),
      left: 0,
      bottom: 0,
      backgroundColor: (props) => (props.transparency ? 'transparent' : theme.colors.white),
      backgroundImage: (props) =>
        props.transparency
          ? 'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))'
          : '',
      [theme.breakpoints.down('sm')]: {
        height: (props) => (props.whiteStripe ? '0' : '70%')
      }
    }
  },
  banner: {
    [theme.breakpoints.up('sm')]: {
      marginTop: (props) => (props.banner !== null ? theme.spacing(4) : 0)
    }
  },
  container: {
    position: 'relative',
    zIndex: 2
  },
  content: {
    display: 'flex',
    flexDirection: (props) =>
      props.imageRight || props.videoUrl || props.reverse ? 'row-reverse' : 'row',
    textAlign: (props) => (props.alignLeft || props.imgUrl2 ? 'left' : 'center'),
    maxWidth: (props) => (props.imgUrl2 ? 'none' : 1140),
    alignItems: (props) =>
      props.heroAnimations ? 'flex-end' : props.hero2Animations ? 'stretch' : 'center',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      flexDirection: (props) => (props.reverse ? 'column-reverse' : 'column'),
      textAlign: (props) => (props.alignLeft || props.imgUrl2 ? 'center' : 'center')
    }
  },
  buttonsWrap: {
    margin: theme.spacing(4, -1, 3),
    justifyContent: (props) => (props.alignLeft || props.imgUrl2 ? 'flex-start' : 'center'),
    '& a': {
      margin: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: (props) => (props.alignLeft || props.imgUrl2 ? 'center' : 'center')
    }
  },
  button: {
    whiteSpace: 'nowrap'
  },
  videoButton: {
    margin: theme.spacing(1),
    whiteSpace: 'nowrap',
    padding: theme.spacing(0, 2, 0, 1.5)
  },
  icon: {
    width: 50,
    height: 50,
    display: 'inline-block',
    marginBottom: '1rem',
    [theme.breakpoints.up('md')]: {
      marginBottom: '1.5rem'
    }
  },
  titleSmall: {
    position: 'relative',
    textTransform: 'none',
    marginBottom: theme.spacing(2)
  },
  image2: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      boxShadow: theme.shadows[4],
      borderRadius: 8,
      maxWidth: '100%',
      margin: 'auto'
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(3, 0, 4)
    }
  },
  imageRight: {
    position: 'relative'
  },
  secondaryMenu: {
    position: 'absolute',
    top: 0,
    width: '100%',
    left: 0,
    zIndex: 2
  },
  title: {
    textTransform: 'none',
    position: 'relative',
    marginBottom: (props) => (props.line ? '2rem' : '0.35em'),
    '&::after': {
      content: (props) => (props.line ? '""' : ''),
      position: 'absolute',
      left: '30%',
      bottom: -16,
      width: '40%',
      height: 1,
      backgroundColor: theme.colors.white
    }
  },
  textWrap: {
    paddingBottom: (props) => (props.whiteStripe ? 90 : props.half ? 50 : 0)
  },
  noUppercase: {
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      //fontSize: '2.5rem'
    }
  },
  textButton: {
    padding: '0 1rem',
    color: 'currentColor',
    '&:hover': {
      color: 'currentColor',
      boxShadow: '2px 2px 10px 0 rgba(1, 49, 63, 0.3), 0 1px 3px 0 rgba(1, 49, 63, 0.3)',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        borderRadius: 4,
        backgroundColor: (props) => (props.color ? props.color : theme.colors.blue5),
        opacity: 0.2
      }
    }
  },
  videoWrap: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    [theme.breakpoints.up('md')]: {
      width: '100%',
      height: '56vw'
    }
  },
  video: {
    width: 'auto',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      width: '100%',
      height: '56vw'
    }
  },
  contentText: {
    maxWidth: 792,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  subtitle: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem'
    }
  }
}))

function Hero(props) {
  const classes = useStyles(props)
  let matches = useMediaQuery('(max-width: 960px)')

  let resizeTimer

  useEffect(() => {
    if (!matches) {
      const calculateVideoHeight = () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(function () {
          const hero = document.querySelector('#hero-banner')
          const video = document.querySelector('#video-frame')
          if (hero && video) {
            const heroH = hero.getBoundingClientRect().height
            const videoH = video.getBoundingClientRect().height
            if (videoH > heroH) {
              const distance = (heroH - videoH) / 2
              video.style.transform = `translateY(${distance}px)`
            } else {
              video.style.display = 'none'
            }
          }
        }, 250)
      }

      if (props.bgVideoUrl) {
        window.addEventListener('load', calculateVideoHeight)
        window.addEventListener('resize', calculateVideoHeight)

        return () => {
          window.removeEventListener('load', calculateVideoHeight)
          window.removeEventListener('resize', calculateVideoHeight)
        }
      }
    }
  }, [])

  return (
    <Box className={classes.root} id="hero-banner">
      {props.bgVideoUrl && !matches && (
        <div className={classes.videoWrap}>
          <ReactPlayer
            id="video-frame"
            className={classes.video}
            muted={true}
            controls={false}
            playing={true}
            height="100%"
            width="100%"
            loop={true}
            url={props.bgVideoUrl}
          />
        </div>
      )}
      <Container maxWidth="lg" className={classes.container}>
        <Grid
          container
          className={classes.content}
          spacing={props.imgUrl2 || props.imageRight ? 4 : 0}
        >
          {props.imgUrl2 && !matches && (
            <Grid item xs={12} md={props.half ? 6 : 4} className={classes.image2}>
              <ImgSet
                src={props.imgUrl2}
                src2x={props.imgUrl2x2}
                src3x={props.imgUrl2x3}
                alt={props.img2Alt}
              />
            </Grid>
          )}
          {(props.imageRight || props.videoUrl) && (
            <Grid item xs={12} md={props.half ? 6 : 4} className={classes.imageRight}>
              {props.videoUrl && (
                <Box style={{ height: '5rem' }} mb={2}>
                  <VideoPulseButton videoUrl={props.videoUrl} />
                </Box>
              )}
              {props.imageRight && !matches && (
                <ImgSet
                  img={props.imageRight}
                  img2x={props.imageRightx2}
                  img3x={props.imageRightx3}
                  imgAlt={props.imageRightAlt}
                />
              )}
            </Grid>
          )}
          {/* {props.heroAnimations && (
            <Grid item xs={12} md={props.half ? 6 : 4} className={classes.imageRight}>
              {props.heroAnimations && <HeroAnimation {...props.heroAnimations} />}
            </Grid>
          )}
          {props.hero2Animations && (
            <Grid item xs={12} md={props.half ? 6 : 4} className={classes.imageRight}>
              {props.hero2Animations && <Hero2Animation {...props.hero2Animations} />}
            </Grid>
          )}
          {props.hero3Animations && (
            <Grid item xs={12} md={props.half ? 6 : 4} className={classes.imageRight}>
              {props.hero3Animations && <Hero3Animation {...props.hero3Animations} />}
            </Grid>
          )} */}
          <Grid item xs={12} md={props.imgUrl2 || props.alignLeft ? (props.half ? 6 : 8) : 12}>
            <div className={classes.textWrap}>
              {props.icon && (
                <img src={props.icon.url} className={classes.icon} alt={props.iconAlt} />
              )}
              <SectionHeaderSmall component="h2" gutterBottom className={classes.titleSmall}>
                {uppercaseString(props.topText)}
              </SectionHeaderSmall>
              {props.titleLarge ? (
                <TitleH2BoldLarge component="h1" gutterBottom className={classes.title}>
                  {uppercaseString(props.title)}
                </TitleH2BoldLarge>
              ) : props.titleSmall ? (
                <TitleH3Bold component="h1" className={classes.noUppercase} gutterBottom>
                  {uppercaseString(props.title)}
                </TitleH3Bold>
              ) : (
                <TitleH2Bold component="h1" className={classes.noUppercase} gutterBottom>
                  {uppercaseString(props.title)}
                </TitleH2Bold>
              )}
              {props.imgUrl2 && matches && (
                <Box className={classes.image2}>
                  <img src={props.imgUrl2} alt={props.img2Alt} />
                </Box>
              )}
              <Typography className={classes.subtitle} variant="h3">
                {props.subtitle}
              </Typography>
              <Typography variant="body1" className={classes.contentText}>
                {props.content}
              </Typography>
              {props.ctas && (
                <Box display="flex" flexWrap="wrap" className={classes.buttonsWrap}>
                  {props.ctas.map((cta, i) => {
                    return cta.isVideo ? (
                      <VideoButton
                        videoUrl={cta.href}
                        cta={cta}
                        color={cta.color ? cta.color : props.color}
                        key={`hero-button${i}`}
                        outlined={props.outlined}
                      />
                    ) : i === 0 ? (
                      <CustomButton
                        key={`hero-button${i}`}
                        href={cta.href}
                        title={cta.title}
                        rel={cta.rel}
                        target={cta.target}
                        variant="contained"
                        color={
                          cta.color ? cta.color : props.color === '#ffffff' ? 'white' : 'secondary'
                        }
                      >
                        {cta.text}
                      </CustomButton>
                    ) : (
                      <CustomButton
                        key={`hero-button${i}`}
                        className={classes.textButton}
                        href={cta.href}
                        title={cta.title}
                        rel={cta.rel}
                        target={cta.target}
                        variant={props.outlined ? 'outlined' : 'text'}
                        color={cta.color}
                        bgcolor={props.color}
                      >
                        {cta.text}
                      </CustomButton>
                    )
                  })}
                </Box>
              )}
            </div>
          </Grid>
        </Grid>
        {props.banner && <Box className={classes.banner}>{props.banner}</Box>}
      </Container>
    </Box>
  )
}

export default Hero

Hero.propTypes = {
  secondaryMenu: PropTypes.bool,
  icon: PropTypes.string,
  iconAlt: PropTypes.string,
  topText: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  imgUrl: PropTypes.string,
  imgUrl2: PropTypes.string,
  img2Alt: PropTypes.string,
  banner: PropTypes.element,
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string
    })
  )
}
